import { useAudioGraphStore } from './useAudioGraphStore';

export const useAudioDevices = () => {
  const availableDevices = useAudioGraphStore((state) => state.availableDevices);
  const currentDevice = useAudioGraphStore((state) => state.device);
  const changeDeviceId = useAudioGraphStore((state) => state.changeDeviceIdTask);

  return {
    availableDevices,
    deviceId: currentDevice?.deviceId,
    changeDeviceId,
  };
};
